@if (selectedVoyage) {
<div class="row">
  <div class="col-md-6">
    <!-- Tabs -->
    <div class="card shadow-sm ">
      <div class="card-body">
        <ul class="nav nav-tabs"
          id="pills-tab"
          role="tablist">
          <li class="nav-item"
            role="presentation">
            <button class="nav-link active"
              id="loading_nor_tab"
              data-bs-toggle="pill"
              data-bs-target="#loading_nor"
              type="button"
              role="tab"
              aria-controls="loading_nor"
              aria-selected="true">NORs ({{selectedVoyage.nors.length}})
            </button>
          </li>
          <li class="nav-item"
            role="presentation">
            <button class="nav-link"
              id="loading_sof_tab"
              data-bs-toggle="pill"
              data-bs-target="#loading_sof"
              type="button"
              role="tab"
              aria-controls="loading_sof"
              aria-selected="false">
              SOFs ({{selectedVoyage.sofs.length}})
            </button>
          </li>
          <li class="nav-item"
            role="presentation">
            <button class="nav-link"
              id="bl_tab"
              data-bs-toggle="pill"
              data-bs-target="#bl"
              type="button"
              role="tab"
              aria-controls="bl"
              aria-selected="false">
              Bill Of Ladings ({{selectedVoyage.billOfLadings.length}})
            </button>
          </li>
          <li class="nav-item"
            role="presentation">
            <button class="nav-link"
              id="discharge_tab"
              data-bs-toggle="pill"
              data-bs-target="#discharge"
              type="button"
              role="tab"
              aria-controls="discharge"
              aria-selected="false">
              Discharges ({{selectedVoyage.discharges.length}})
            </button>
          </li>
          <li class="nav-item"
            role="presentation">
            <button class="nav-link"
              id="comments_tab"
              data-bs-toggle="pill"
              data-bs-target="#comments"
              type="button"
              role="tab"
              aria-controls="comments"
              aria-selected="false">
              Comments ({{selectedVoyage.comments.length}})
            </button>
          </li>
          <li class="nav-item"
            role="presentation">
            <button class="nav-link"
              id="documents_tab"
              data-bs-toggle="pill"
              data-bs-target="#documents"
              type="button"
              role="tab"
              aria-controls="documents"
              aria-selected="false">
              Documents ({{selectedVoyage.miscDocuments.length}})
            </button>
          </li>
        </ul>
        <div class="tab-content"
          id="pills-tabContent">
          <div class="tab-pane fade show active"
            id="loading_nor"
            role="tabpanel"
            aria-labelledby="loading_nor_tab">
            @if (selectedVoyage.nors.length > 0 ) {
            <table class="table table-sm table-bordered table-striped voyage-table voyage-table--nor">
              <thead>
                <tr>
                <th></th>
                <th>Type</th>
                <th>Port</th>
                <th>Date</th>
                </tr>
              </thead>
              <tbody>
                @for (nor of selectedVoyage.nors ; let i=$index; track $index) {
                <tr>
                  <td class="text-center" style="width: 80px">
                      <div class="icon-set">
                      @if (nor.fileId) {
                        <!-- Download -->
                        <a (click)="downloadFile(nor.fileId, 'nor')">
                          <i class="fa fa-download" aria-hidden="true"></i>
                        </a>
                        &nbsp;
                        <!-- Delete -->
                        <a (click)="deleteDocument(selectedVoyage.nors, nor)">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </a>
                      }
                    </div> 
                  </td>
                  <td class="text-center">
                    <a id="previewNor"
                      (click)="routToDocument('nor', nor.fileId)"
                      class="btn btn-link text-decoration-none">{{nor.norType}}</a>
                  </td>
                  <td class="text-center">{{findOrganisation(nor.portOrganisationId)}}</td>
                  <td class="text-center">{{formatDate(nor.timestamp,nor.portOrganisationId)}}</td>
                </tr>
                }
              </tbody>
            </table>
            }
          </div>
          <div class="tab-pane fade"
            id="loading_sof"
            role="tabpanel"
            aria-labelledby="loading_sof_tab">
            @if (selectedVoyage.sofs.length > 0 ) {
            <table class="table table-sm table-bordered table-striped voyage-table voyage-table--sof">
              <thead>
                <tr>
                  <th></th>
                  <th>Type</th>
                  <th>Port</th>
                </tr>
              </thead>
              <tbody>
                @for (sof of selectedVoyage.sofs ; let i=$index; track $index) {
                <tr>
                  <td class="text-center" style="width: 80px">
                      <div class="icon-set " >
                      @if (sof.fileId) {
                        <!-- Download -->
                        <a (click)="downloadFile(sof.fileId, 'sof')">
                          <i class="fa fa-download" aria-hidden="true"></i>
                        </a>
                        &nbsp;
                        <!-- Delete -->
                        <a (click)="deleteDocument(selectedVoyage.sofs, sof)">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </a>
                      }
                    </div>                  
                  </td>
                  <td class="text-center">
                    <a id="editSof"
                      class="btn btn-link text-decoration-none"
                      (click)="routToDocument('sof', sof.fileId)">
                      {{sof.sofType}}</a>
                  </td>
                  <td class="text-center">{{findOrganisation(sof.portOrganisationId)}}</td>
                </tr>
                }
              </tbody>
            </table>
            }
          </div>
          <div class="tab-pane fade"
            id="bl"
            role="tabpanel"
            aria-labelledby="bl_tab">
            @if (selectedVoyage.billOfLadings.length > 0 ) {
            <table class="table table-sm table-bordered table-striped voyage-table voyage-table--bl">
              <thead>
                <tr>
                  <th></th>
                  <th>Date</th>
                  <th>Port</th>
                  <th>Product</th>
                  <th>Revise</th>
                </tr>
              </thead>
              <tbody>
                @for (bl of selectedVoyage.billOfLadings ; let i=$index; track $index) {
                <tr>
                  <td class="text-center" style="width: 80px">
                      <div class="icon-set">
                      @if (bl.fileId) {
                        <!-- Download -->
                        <a (click)="downloadFile(bl.fileId, 'bl')">
                          <i class="fa fa-download" aria-hidden="true"></i>
                        </a>
                        &nbsp;
                        <!-- Delete -->
                        <a (click)="deleteDocument(selectedVoyage.billOfLadings, bl)">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </a>
                      }
                    </div>
                  </td>
                  <td class="text-center">
                    <a id="editBL"
                      class="btn btn-link text-decoration-none"
                      (click)="routToDocument('bl', bl.fileId)">
                      {{formatDate(bl.date,bl.loadingPortOrganisationId)}}</a>
                  </td>
                  <td class="text-center">{{findOrganisation(bl.loadingPortOrganisationId)}}</td>
                  <td class="text-center">{{formatProducts(bl)}}</td>
                  <td class="text-center">@if (bl?.revise) {
                    <i class="fa fa-check-square-o text-success"></i>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
            }
          </div>
          <div class="tab-pane fade"
            id="discharge"
            role="tabpanel"
            aria-labelledby="discharge_tab">
            @if (selectedVoyage.discharges.length > 0 ) {
            <table class="table table-sm table-bordered table-striped voyage-table voyage-table--discharg">
              <thead>
                <tr>
                  <th></th>
                  <th>Date</th>
                  <th>Port</th>
                  <th>Consignee</th>
                  <th>Products</th>
                  <th>Primary</th>
                </tr>
              </thead>
              <tbody>
                @for (discharge of selectedVoyage.discharges ; let i=$index; track $index) {
                <tr>
                  <td class="text-center" style="width: 80px">
                      <div class="icon-set">
                      @if (discharge.fileId) {
                        <!-- Download -->
                        <a (click)="downloadFile(discharge.fileId, 'discharge')">
                          <i class="fa fa-download" aria-hidden="true"></i>
                        </a>
                        &nbsp;
                        <!-- Delete -->
                        <a (click)="deleteDocument(selectedVoyage.discharges, discharge)">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </a>
                      }
                    </div>
                  </td>
                  <td class="text-center">
                    <a id="edit"
                      class="btn btn-link text-decoration-none"
                      (click)="routToDocument('discharge', discharge.fileId)">
                      {{formatDate(discharge.date,discharge.portOrganisationId)}}
                    </a>
                  </td>
                  <td class="text-center">{{findOrganisation(discharge.portOrganisationId)}}</td>
                  <td class="text-center">{{findOrganisation(discharge.consigneeOrganisationId!)}}
                  </td>
                  <td class="text-center">
                    @for (p of sumDischarges(discharge); track $index) {
                    {{p['product']}}:{{p['weight'] | number}}
                    }
                  </td>
                  <td class="text-center">@if (containsPrimary(discharge)) {
                    <i class="fa fa-check-square-o text-success"></i>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
            }
          </div>
          <div class="tab-pane fade"
            id="comments"
            role="tabpanel"
            aria-labelledby="comments_tab">
            @if (selectedVoyage.comments.length > 0 ) {
            <table class="table table-sm table-bordered table-striped voyage-table voyage-table--comments">
              <thead>
                <tr>
                  <th></th>
                  <th>Author</th>
                  <th>Date</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                @for (comment of selectedVoyage.comments ; let i=$index; track $index) {
                <tr>
                  <td class="text-center" style="width: 80px">
                  <div class="icon-set">
                    @if (comment.fileId) {
                      <!-- Download -->
                      <a (click)="downloadFile(comment.fileId, 'comment')">
                        <i class="fa fa-download" aria-hidden="true"></i>
                      </a>
                      &nbsp;
                      <!-- Delete -->
                      <a (click)="deleteDocument(selectedVoyage.comments, comment)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </a>
                    }
                  </div>
                  </td>
                  <td class="text-center">{{comment.author}}</td>
                  <td class="text-center">{{comment.incidentTimestamp |
                    date}}</td>
                  <td class="text-center">
                    <p>{{comment.content}}</p>
                  </td>
                </tr>
                }
              </tbody>
            </table>
            }
          </div>
          <div class="tab-pane fade"
            id="documents"
            role="tabpanel"
            aria-labelledby="documents_tab">
            @if (selectedVoyage.miscDocuments.length > 0 ) {
            <table class="table table-sm table-bordered table-striped voyage-table voyage-table--comments">
              <thead>
                <tr>
                  <th></th>
                  <th>Type</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                @for (miscDocument of selectedVoyage.miscDocuments ; let i=$index; track $index) {
                <tr>
                  <td class="text-center" style="width: 80px">
                    <div class="icon-set">
                      @if (miscDocument.fileId) {
                        <!-- Download -->
                        <a (click)="downloadFile(miscDocument.fileId, 'misc')">
                          <i class="fa fa-download" aria-hidden="true"></i>
                        </a>
                        &nbsp;
                        <!-- Delete -->
                        <a (click)="deleteDocument(selectedVoyage.miscDocuments, miscDocument)">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </a>
                      }
                    </div>
                  </td>
                  <td class="text-center">{{miscDocument.miscDocumentType}}</td>
                  <td class="text-center">{{miscDocument.comment}}</td>
                </tr>
                }
              </tbody>
            </table>
            }
          </div>
          <div class="tab-pane fade"
            id="pills-contact"
            role="tabpanel"
            aria-labelledby="bl_tab">
            ...
          </div>
        </div>
      </div>
    </div>
  </div>
    <div class="col-md-6">
      <!-- Voyage Summery -->
      <div class="card shadow-sm ">
        @if (volumes !== undefined) {
        <div class="card-body">
          <table class="table table-sm table-striped table-bordered">
            <thead>
              <tr>
                <td class="bg-info text-center">Items</td>
                <td class="bg-primary text-center">Loading</td>
                <td class="bg-success text-center">Discharging</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">No. Of Ports</td>
                <td class="text-center">{{volumes.noLoadingPorts |
                  number}}</td>
                <td>{{volumes.noDischargePorts | number}}</td>
              </tr>
              <tr>
                <td class="text-center">Ports</td>
                <td class="text-center">
                  @for (p of volumes.loadPorts; track $index) {
                  <span>{{p}}</span>
                  <br>
                  }
                </td>
                <td class="text-center">
                  @for (p of volumes.dischargePorts; track $index) {
                  <span>{{p}}</span>
                  <br>
                  }
                </td>
              </tr>
              <tr>
                <td class="text-center">Weight (Ton)</td>
                <td class="text-center">
                  <span>Real: <br>
                    @for (p of volumes.loadingRealWeight; track $index) {
                    {{p['product']}}: {{p['grossWeight'] | number}}<br>
                    }
                  </span>
                  <span>Revise: <br>
                    @for (p of volumes.loadingReviseWeight; track $index) {
                    {{p['product']}}: {{p['grossWeight'] | number}}<br>
                    }
                  </span>
                </td>
                <td class="text-center">
                  @for (p of volumes.dischargeWeight; track $index) {
                  {{p['product']}}: {{p['weight'] | number}}<br>
                  }
                </td>
              </tr>
              <tr>
                <td class="text-center">Berth Time (Hours)</td>
                <td class="text-center">{{volumes.loadingBerthTime | number}}
                </td>
                <td>{{volumes.dischargeBerthTime | number}} </td>
              </tr>
              <tr>
                <td class="text-center">Laytime (Hours)</td>
                <td class="text-center">{{volumes.loadingLaytime | number}}
                </td>
                <td>{{volumes.dischargeLaytime | number}} </td>
              </tr>
              <tr>
                <td class="text-center">Total Real Weight</td>
                <td class="text-center">{{volumes.allLoading | number}} </td>
                <td class="text-center">{{volumes.allDischarging | number}} </td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <td colspan="3"
                  class="text-center bg-warning text-center">Differences</td>
              </tr>
              <tr>
                <td class="text-center"
                  colspan="2">Time between Loading Discharge
                  (Days)</td>
                <td class="text-center">Weight Difference (Ton)</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center"
                  colspan="2">{{volumes.timeBetweenLoadingDis}} </td>
                <td>
                  @for (d of volumes?.diff; track $index) {
                  <span>{{d['product']}}: {{d['diff'] | number}}</span><br>
                  }
                </td>
              </tr>
              <tr>
                <td class="text-center"
                  colspan="2">Total Difference</td>
                <td class="text-center">{{volumes.allDiff | number}} </td>
              </tr>
            </tbody>
          </table>
          <span class="info">Weight differences are between Real BL and primary
            discharges</span>
        </div>
        }
      </div>
    </div>
</div>
}
